<div
	class="grid grid-cols-1 h-full"
	style="grid-template-rows: min-content min-content 1fr min-content"
>
	<div class="flex items-baseline p-6 border-b-2 border-grey-veryLight">
		<div class="text-grey-darker font-semibold text-[28px]">
			Select mortgage instructions
		</div>
		<div class="flex-auto"></div>
		<div class="text-grey">Step 1 of 2</div>
	</div>

	<!-- filter bar -->
	<div class="flex justify-between items-center p-6 pb-2.5">
		<ng-container *ngIf="filters$ | async as filters">
			<div class="flex items-center gap-2" *ngIf="filters.length">
				<span class="mr-1">Filter</span>
				<ng-container *ngFor="let option of filters">
					<ng-container
						*ngTemplateOutlet="filterOption; context: { option: option }"
					></ng-container>
				</ng-container>
			</div>
		</ng-container>
		<app-button
			[icon]="ICON.LIGHTNING_BOLT"
			size="xsmall"
			btn="clear"
			(click)="onConnectLawyerClick()"
			>Connect lawyer to LLC</app-button
		>
	</div>

	<!-- main table -->
	<div
		class="border-grey-lighter border rounded-[12px] mx-6 mb-6 h-full overflow-hidden"
	>
		<div class="h-full w-full overflow-auto">
			<table mat-table [dataSource]="data$ | async" matSort class="w-full">
				<ng-container matColumnDef="source">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Source</th>
					<td mat-cell *matCellDef="let element">
						<ng-container
							*ngIf="
								element?.source === TRANSACTION_SOURCE.LLC;
								else otherSource
							"
						>
							<span
								class="flex flex-row justify-center align-middle items-center my-2"
								><img
									src="/assets/images/integrations/llc-logo.png"
									alt="LLC"
									class="w-12"
							/></span>
						</ng-container>
						<ng-template #otherSource>
							<span
								class="flex flex-row justify-center align-middle items-center my-2"
								><img
									src="/assets/images/integrations/sync-logo.png"
									alt="Closer SYNC"
									class="w-12"
							/></span>
						</ng-template>
					</td>
				</ng-container>

				<ng-container matColumnDef="lawyer">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Lawyer</th>
					<td mat-cell *matCellDef="let element">
						<app-business-user
							[showName]="false"
							[userId]="element.lawyer"
						></app-business-user>
					</td>
				</ng-container>

				<ng-container matColumnDef="borrowers">
					<th mat-header-cell *matHeaderCellDef>Borrower(s)</th>
					<td mat-cell *matCellDef="let element">
						<div *ngFor="let borrower of element.borrowers">{{ borrower }}</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="address">
					<th mat-header-cell *matHeaderCellDef>Address</th>
					<td mat-cell *matCellDef="let element">
						<div>
							<span *ngIf="element.address?.unitNumber"
								>{{ element.address.unitNumber }}-</span
							>
							<span *ngIf="element.address?.streetNumber"
								>{{ element.address.streetNumber }}
							</span>
							<span *ngIf="element.address?.streetAddress1">{{
								element.address.streetAddress1
							}}</span>
						</div>
						<div>
							<span *ngIf="element.address?.city"
								>{{ element.address.city }}
							</span>
							<span *ngIf="element.address?.province"
								>{{ element.address.province }}
							</span>
							<span *ngIf="element.address?.postalCode">{{
								element.address.postalCode
							}}</span>
						</div>
					</td>
				</ng-container>

				<ng-container matColumnDef="lender">
					<th mat-header-cell *matHeaderCellDef mat-sort-header>Lender</th>
					<td mat-cell *matCellDef="let element">
						<span class="flex flex-row align-middle items-center">
							<app-lender
								[shortName]="element.lenderShortName"
								[showShortName]="element.lenderShowShortName"
								[showName]="element.lenderShowName"
								imageWrapperClass="w-14"
								[logoUrl]="element.lenderLogoUrl"
							></app-lender>
						</span>
					</td>
				</ng-container>

				<ng-container matColumnDef="principalAmount">
					<th mat-header-cell *matHeaderCellDef>Principal amount</th>
					<td mat-cell *matCellDef="let element">
						{{ element.principalAmount | centsToDollars }}
					</td>
				</ng-container>

				<ng-container matColumnDef="closingDate">
					<th mat-header-cell *matHeaderCellDef>Closing date</th>
					<td mat-cell *matCellDef="let element">
						{{ element.closingDate | closerDate }}
					</td>
				</ng-container>

				<tr
					mat-header-row
					*matHeaderRowDef="displayedColumns"
					class="sticky top-0 z-10"
				></tr>
				<tr
					mat-row
					*matRowDef="let row; columns: displayedColumns"
					[class.selected]="(selectedRow$ | async) === row"
					(click)="selectedRow$.next(row)"
				></tr>

				<tr *matNoDataRow>
					<td class="mat-cell" colspan="6">
						<ng-container
							*ngIf="tryRemovingFilter$ | async; else noMatchingRecords"
						>
							No instructions match your filters.
						</ng-container>
					</td>
				</tr>
			</table>
		</div>
	</div>

	<div class="p-6 flex items-center">
		<app-button mat-dialog-close btn="border">Cancel</app-button>
		<div class="flex-auto flex justify-center px-2">
			<atomic-message-bar
				type="error"
				*ngIf="mmsInvalidFileTypeWarning$ | async as mmsInvalidMessage"
				>{{ mmsInvalidMessage }}</atomic-message-bar
			>
		</div>
		<app-button
			[disabled]="selectDisabled$ | async"
			(click)="onSelectMortgageClick()"
			[loading]="working$ | async"
			>Select mortgage</app-button
		>
	</div>
</div>

<ng-template #filterOption let-option="option">
	<div
		class="flex items-center rounded border-[1.5px] border-grey-lighter bg-grey-lightest px-2 h-[28px] text-grey-darker text-xs"
	>
		<div
			*ngIf="option.initials"
			class="flex items-center p-1 rounded-full text-xs bg-blue-lighter mr-2"
		>
			{{ option.label | initials }}
		</div>
		{{ option.label }}
		<app-icon
			*ngIf="!option.locked"
			[icon]="ICON.CIRCLE_X"
			(click)="removeFilter(option)"
			class="text-sm text-grey-darker ml-1 cursor-pointer"
			matTooltip="Remove {{ option.label }}"
		></app-icon>
	</div>
</ng-template>

<ng-template #noMatchingRecords> No instructions found. </ng-template>
